module.exports = __webpack_public_path__ + "static/media/logo_cqcs.e2b17109.png";